module.exports = __webpack_public_path__ + "static/media/ic_email.3e9a4c5e.svg";